/*----------------------------------
- ROUTE: /tld/applications
----------------------------------*/

/**
 * @docs docs/features/agenda
 * @adr  ADR-0055
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { definePageRoute } from '@common/router/definitions';

import { buildTldApplicationsRouteData, renderTldApplicationsRoute } from './lib/applicationsRoute';

import './applicationsPagination';

/*----------------------------------
- PAGE
----------------------------------*/

// SSR on every request (D12), never static: a static page is cached by path, so it could not
// page, and the Reveal Day import must show at once without a deploy or a cache refresh.
export default definePageRoute({
    path: '/tld/applications',
    options: { auth: false, layout: false },
    data: buildTldApplicationsRouteData,
    render: renderTldApplicationsRoute,
});
